import React from 'react';
import { Container, StatusBox } from './styles';
import { IFabricationOrder } from '../../../../../store/ducks/fabrication-orders/types';
import { KeyValueItem } from '@gerdau/hefesto-mais-web';
import { Title } from '@gerdau/hefesto';

interface IOrderDetailsProps {
  fabricationOrder: IFabricationOrder;
}

const OrderDetails: React.FC<IOrderDetailsProps> = ({ fabricationOrder }) => {
  const statusOrder = {
    1: 'Enviado',
    3: 'Confirmado',
    5: 'Em produção',
    6: 'Parcialmente faturado',
    7: 'Faturado',
    8: 'Cancelado',
    9: 'Bloqueado'
  };

  const total = fabricationOrder.deliveries
    .reduce((acc, curr) => (curr.totalWeight || 0) + acc, 0)
    .toFixed(2)
    .toString()
    .replace('.', ',');

  return (
    <Container>
      <Title level={2}>Pedido</Title>
      <div>
        <KeyValueItem
          title="Nº do pedido"
          children={fabricationOrder.orderNumber}
        />

        <KeyValueItem
          title="Quantidade de entregas"
          children={
            fabricationOrder.deliveries.length > 0
              ? fabricationOrder.deliveries.length.toString()
              : '-'
          }
        />

        <KeyValueItem
          title="Status do pedido"
          children={
            <StatusBox>
              <div> {statusOrder[fabricationOrder.orderStatus]}</div>
              <div>Solicitado: {total}T</div>
            </StatusBox>
          }
        />
      </div>

      <div>
        <KeyValueItem
          title="Observações"
          children={fabricationOrder.logisticObservation || '-'}
        />
      </div>
    </Container>
  );
};

export default OrderDetails;
